import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const grantMarketing = () => {
  if (window.gtag) window.gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  });
};

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = localStorage.getItem("cookie-consent");
    if (!c) setVisible(true);
    else if (c === "all") grantMarketing();
  }, []);

  if (!visible) return null;
  if (process.env.REACT_APP_IUBENDA_SITE_ID) return null;

  const acceptAll = () => {
    localStorage.setItem("cookie-consent", "all");
    grantMarketing();
    setVisible(false);
  };
  const essentialOnly = () => {
    localStorage.setItem("cookie-consent", "essential");
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-[#0A0F1A] text-white px-6 py-4" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <p className="text-sm leading-relaxed max-w-3xl">
          {t("cookie_msg")}{" "}
          <Link to="/cookies" className="underline hover:text-[#FFD700]">{t("cookie_link")}</Link>.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-reject-btn"
            onClick={essentialOnly}
            className="label-mono border border-white/40 text-white px-5 py-2.5 hover:bg-white/10 transition-colors">
            {t("cookie_reject")}
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={acceptAll}
            className="label-mono bg-[#FFD700] text-[#0A0F1A] px-6 py-2.5 hover:bg-white transition-colors">
            {t("cookie_accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
